<template>
  <!-- placeholders de carga: no aportan nada a un lector de pantalla -->
  <!--
    Lleva las clases .productCard y .lightBackground a proposito: asi el borde,
    el radio, el padding de .texts y el alto de linea del titulo los pone
    productCards.css y no hay que replicarlos aqui. Dos lineas de titulo, que es
    lo que ocupa la mayoria de nombres de articulo truncados a 35 caracteres.
  -->
  <div class="productCards alignLeft" v-if="type === 'card'" aria-hidden="true">
    <div class="productCard lightBackground catalogueSkeletonCard" v-for="index in total" :key="index">
      <div class="image"></div>
      <div class="texts">
        <div class="title">&nbsp;<br>&nbsp;</div>
      </div>
    </div>
  </div>

  <div class="catalogueSkeletonRows" v-else aria-hidden="true">
    <div class="catalogueSkeletonRow" v-for="index in total" :key="index"></div>
  </div>
</template>

<script>
import { computed } from 'vue'

/**
 * Placeholders de carga del catalogo. 'card' replica la geometria de
 * .productCard (200px de ancho, imagen cuadrada) para que la parrilla real no
 * provoque salto de layout al llegar; 'row' replica las filas del rail.
 *
 * Se usan skeletons en lugar del half-circle-spinner del resto del proyecto
 * porque el catalogo tiene dos regiones asincronas independientes y un spinner
 * unico bloquearia visualmente las dos.
 */
export default {
  name: 'CatalogueSkeleton',
  props: {
    type: {
      type: String,
      default: 'card'
    },
    count: {
      type: Number,
      default: null
    }
  },
  setup(props) {
    const total = computed(() => {
      if (props.count) return props.count

      return props.type === 'card' ? 12 : 8
    })

    return { total }
  }
}
</script>
